import { render, staticRenderFns } from "./publicFunds.vue?vue&type=template&id=2871dd19&scoped=true&"
import script from "./publicFunds.vue?vue&type=script&lang=js&"
export * from "./publicFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871dd19",
  null
  
)

export default component.exports